module.exports = __webpack_public_path__ + "img/icn_user.07426687.svg";